import { useContext } from 'react';
import { Link } from 'react-router-dom';

import { GlobalContext } from '@contexts';
import { ChevronRightIcon } from '@svgs';

export const TemplateBreadcrumbs = ({ children, businessData, siteData }) => {
  // base template routes breadcrumbs
  const globals = useContext(GlobalContext);

  return (
    <div className="sb-main-breadcrumbs">
      <ul className="sb-flex">
        {globals.visible.projectsView && (
          <li className="sb-flex">
            <Link to={`/dashboard/projects`}>Projects</Link>
            <ChevronRightIcon />
          </li>
        )}
        <li className="sb-flex">
          {!businessData && <span>...</span>}
          {businessData && (
            <Link to={`/dashboard/projects/${businessData.id}`}>
              {businessData.business_name}
            </Link>
          )}
          <ChevronRightIcon />
        </li>
        <li className="sb-flex">
          {!businessData && <>...</>}
          {businessData && (
            <Link to={`/dashboard/projects/${businessData.id}/templates`}>
              Templates
            </Link>
          )}
          <ChevronRightIcon />
        </li>
        <li className="sb-flex">
          {(!siteData || !businessData) && <>...</>}
          {siteData && businessData && (
            <Link
              to={`/dashboard/projects/${businessData.id}/templates/${siteData.id}`}
            >
              {siteData.title}
            </Link>
          )}
          <ChevronRightIcon />
        </li>
        {children}
      </ul>
    </div>
  );
};
